<div class="footer-main">
  <div class="footer-inner">
    <div class="left-side">
      <div class="logo">
        <a routerLink="/">
          <img [src]="s3BucketUrl + '/ASSETS/GENERAL/LOGO/footer-logo-white.svg'" width="202" height="57" alt="logo"
            loading="lazy" appHandleImageError>
        </a>
      </div>
      <div class="social-media">
        <p class="social-media-title">Join us on social media</p>
        <div class="social-media-icon">
          @for (social of socialLinks; track social.label) {
          <a [href]="social.url" rel="noopener noreferrer nofollow" [attr.aria-label]="social.label" target="_blank"
            class="icon">
            <img [src]="s3BucketUrl + social.iconPath" width="32" height="32" [alt]="social.label" appHandleImageError>
          </a>
          }
        </div>
      </div>
    </div>
    <div class="center-side" [class.flex-auto]="isUserAuthenticated !== false">
      <div class="footer-menu">
        @for (menu of footerMenus; track menu.title) {
        <ul>
          <li class="menu-title">{{ menu.title }}</li>
          @for (item of menu.items; track item.label) {
          <li>
            @if(!item.conditional || (item.conditional && isPlatformBrowser(platformId) && isUserAuthenticated)) {
            <a class="nav-link" [class.outlet]="item.label=='Outlet'" [routerLink]="item.route"
              routerLinkActive="active">{{ item.label }}</a>
            }
            @if(item.conditional && !isUserAuthenticated) {
            <span class="nav-link grey-price-menu" placement="auto" [ngbTooltip]="item.tooltip">
              {{ item.label }}
            </span>
            }
          </li>
          }
        </ul>
        }
      </div>
    </div>
    @if (isUserAuthenticated == false) {
    <div class="right-side sign">
      <p class="right-side-content">Construction industry professional?</p>
      <h3 class="right-side-title">REGISTER FOR FULL ACCESS</h3>
      <button type="button" class="btn btn-primary" (click)="openSignUpModal()">
        <span class="btn-primary-hover"></span>
        <span class="btn-content">Get Started</span>
      </button>
    </div>
    }
  </div>
</div>
<div class="copyright-section" [class]="productDetailClass">
  <div class="copyright">
    <p class="copyright-content">&#169; {{ currentYear }} GatherCo. All rights reserved</p>
  </div>
  <div class="copyright-left-side">
    @for (payment of paymentLogos; track payment.alt) {
    <img [src]="s3BucketUrl + payment.path" [alt]="payment.alt" [width]="payment.width" [height]="payment.height"
      loading="lazy" appHandleImageError>
    }
  </div>
  <div class="copyright-right-side">
    <ul>
      <li><a [routerLink]="['/', ROUTES.TERMS_AND_CONDITIONS]" routerLinkActive="active" class="nav-link">Terms and
          Conditions</a></li>
      <li><a [routerLink]="['/', ROUTES.PRIVACY_POLICY]" routerLinkActive="active" class="nav-link">Privacy and
          Policy</a></li>
    </ul>
  </div>
</div>
